import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function TeachersPage() {
  const departments = [
    {
      name: '수학과',
      icon: 'ri-calculator-line',
      color: 'from-rose-500 to-red-600',
      teachers: [
        { 
          id: 1, 
          name: '이현우', 
          careers: [
            '미래인재학원 옥정캠퍼스 부원장',
            '미래인재학원 옥정캠퍼스 수학과 팀장',
            '고려대학교'
          ] 
        },
        { 
          id: 2, 
          name: '강창석', 
          careers: [
            '미래인재학원 지행캠퍼스 원장',
            '미래인재학원 옥정캠퍼스 수학 전임',
            ''
          ] 
        },
        { 
          id: 3, 
          name: '허기욱', 
          careers: [
            '미래인재학원 옥정캠퍼스 수학 전임 강사',
            '전 열린학원',
            ''
          ]
        },
        { 
          id: 6, 
          name: '고민정', 
          careers: [
            '미래인재학원 옥정캠퍼스 수학 전임 강사',
            '세종대학교',
            ''
          ] 
        },
        { 
          id: 4, 
          name: '신민석', 
          careers: [
            '미래인재학원 옥정캠퍼스 수학 전임 강사',
            '건국대학교',
            ''
          ] 
        },
        { 
          id: 5, 
          name: '도강현', 
          careers: [
            '미래인재학원 옥정캠퍼스 수학 전임 강사',
            '고려대학교',
            ''
          ] 
        },
        { 
          id: 7, 
          name: '김한기', 
          careers: [
            '미래인재학원 민락캠퍼스 수학 전임 강사',
            '포항공과대학교',
            ''
          ] 
        },
        { 
          id: 9, 
          name: '강영채', 
          careers: [
            '미래인재학원 민락캠퍼스 수학 전임 강사',
            '',
            ''
          ] 
        },
        { 
          id: 8, 
          name: '이미현', 
          careers: [
            '미래인재학원 민락캠퍼스 수학 전임 강사',
            '',
            ''
          ] 
        },
      ]
    },
    {
      name: '영어과',
      icon: 'ri-english-input',
      color: 'from-emerald-500 to-teal-600',
      teachers: [
        { 
          id: 10, 
          name: '황지현', 
          careers: [
            '미래인재학원 옥정캠퍼스 부원장',
            '미래인재학원 옥정캠퍼스 옥빛고 영어 팀장',
            ''
          ] 
        },
        { 
          id: 11, 
          name: '이정식', 
          careers: [
            '미래인재학원 옥정캠퍼스 영어 전임 강사',
            '미래인재학원 옥정캠퍼스 옥정고 영어 팀장',
            'De Montfort University'
          ] 
        },
        { 
          id: 12, 
          name: '정재은', 
          careers: [
            '미래인재학원 옥정캠퍼스 영어 전임 강사',
            '성신여자대학교 영어영문학과',
            ''
          ] 
        },
        { 
          id: 13, 
          name: '박지은', 
          careers: [
            '미래인재학원 옥정캠퍼스 영어 전임 강사',
            '전 한샘학원',
            '동국대학교'
          ] 
        },
        { 
          id: 14, 
          name: '홍준성', 
          careers: [
            '미래인재학원 옥정캠퍼스 영어 전임 강사',
            '외고, 영어영문학과 졸업',
            ''
          ] 
        },
        { 
          id: 15, 
          name: '남보람', 
          careers: [
            '미래인재학원 민락캠퍼스 영어 전임 강사',
            '한양대학교 사범대학',
            ''
          ] 
        },
        { 
          id: 16, 
          name: '김아현', 
          careers: [
            '미래인재학원 민락캠퍼스 영어 전임 강사',
            '서강대학교',
            ''
          ] 
        },
        { 
          id: 17, 
          name: '박혁호', 
          careers: [
            '미래인재학원 지행캠퍼스 영어 전임 강사',
            '한국외국어대학교',
            ''
          ] 
        },
      ]
    },
    {
      name: '국어과',
      icon: 'ri-book-2-line',
      color: 'from-amber-500 to-orange-600',
      teachers: [
        { 
          id: 18, 
          name: '김지원', 
          careers: [
            '미래인재학원 옥정캠퍼스 국어 전임 강사',
            '미래인재학원 옥정캠퍼스 국어과 팀장',
            '경희대학교 국어국문학과'
          ] 
        },
        { 
          id: 19, 
          name: '민세인', 
          careers: [
            '미래인재학원 옥정캠퍼스 국어 전임 강사',
            '전 노원 드릴스터디',
            '서울여자대학교'
          ] 
        },
      ]
    },
    {
      name: '과학과',
      icon: 'ri-flask-line',
      color: 'from-sky-500 to-cyan-600',
      teachers: [
        { 
          id: 20, 
          name: '임소희', 
          careers: [
            '미래인재학원 옥정캠퍼스 과학과 팀장',
            '통합과학, 화학 담당',
            '건국대학교 화학과'
          ] 
        },
        { 
          id: 21, 
          name: '김규리', 
          careers: [
            '미래인재학원 옥정캠퍼스 과학 전임 강사',
            '통합과학, 생물, 물리 담당',
            '성신여자대학교'
          ] 
        },
      ]
    }
  ];

  const [activeTab, setActiveTab] = useState('');

  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 강사진 - 민락·옥정·지행';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '미래인재학원 우수한 강사진을 소개합니다. 수학, 영어, 국어, 과학 전문 강사진이 학생들의 성공을 이끕니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 강사진 소개 - 민락, 옥정, 지행 입시 전문 교사');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '미래인재학원 우수한 강사진을 소개합니다. 수학, 영어, 국어, 과학 전문 강사진이 학생들의 성공을 이끕니다.');
    }

    // Schema.org Person structured data for teachers
    const existingSchema = document.getElementById('schema-teachers');
    if (!existingSchema) {
      const teacherSchemaData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "미래인재학원 강사진",
        "description": "미래인재학원의 우수한 강사진. 수학, 영어, 국어, 과학 과목별 전문 교사진.",
        "numberOfItems": 21,
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "item": { "@type": "Person", "name": "이현우", "jobTitle": "옥정캠퍼스 부원장 / 수학과 팀장", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "고려대학교", "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 2, "item": { "@type": "Person", "name": "강창석", "jobTitle": "지행캠퍼스 원장", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 3, "item": { "@type": "Person", "name": "허기욱", "jobTitle": "옥정캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 4, "item": { "@type": "Person", "name": "고민정", "jobTitle": "옥정캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "세종대학교", "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 5, "item": { "@type": "Person", "name": "신민석", "jobTitle": "옥정캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "건국대학교", "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 6, "item": { "@type": "Person", "name": "도강현", "jobTitle": "옥정캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "고려대학교", "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 7, "item": { "@type": "Person", "name": "김한기", "jobTitle": "민락캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "포항공과대학교", "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 8, "item": { "@type": "Person", "name": "강영채", "jobTitle": "민락캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 9, "item": { "@type": "Person", "name": "이미현", "jobTitle": "민락캠퍼스 수학 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "knowsAbout": "수학" } },
          { "@type": "ListItem", "position": 10, "item": { "@type": "Person", "name": "황지현", "jobTitle": "옥정캠퍼스 부원장 / 옥빛고 영어 팀장", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 11, "item": { "@type": "Person", "name": "이정식", "jobTitle": "옥정캠퍼스 영어 전임 강사 / 옥정고 영어 팀장", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "De Montfort University", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 12, "item": { "@type": "Person", "name": "정재은", "jobTitle": "옥정캠퍼스 영어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "성신여자대학교 영어영문학과", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 13, "item": { "@type": "Person", "name": "박지은", "jobTitle": "옥정캠퍼스 영어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "동국대학교", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 14, "item": { "@type": "Person", "name": "홍준성", "jobTitle": "옥정캠퍼스 영어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "외국어고등학교, 영어영문학과", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 15, "item": { "@type": "Person", "name": "남보람", "jobTitle": "민락캠퍼스 영어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "한양대학교 사범대학", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 16, "item": { "@type": "Person", "name": "김아현", "jobTitle": "민락캠퍼스 영어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "서강대학교", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 17, "item": { "@type": "Person", "name": "박혁호", "jobTitle": "지행캠퍼스 영어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "한국외국어대학교", "knowsAbout": "영어" } },
          { "@type": "ListItem", "position": 18, "item": { "@type": "Person", "name": "김지원", "jobTitle": "옥정캠퍼스 국어 전임 강사 / 국어과 팀장", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "경희대학교 국어국문학과", "knowsAbout": "국어" } },
          { "@type": "ListItem", "position": 19, "item": { "@type": "Person", "name": "민세인", "jobTitle": "옥정캠퍼스 국어 전임 강사", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "서울여자대학교", "knowsAbout": "국어" } },
          { "@type": "ListItem", "position": 20, "item": { "@type": "Person", "name": "임소희", "jobTitle": "옥정캠퍼스 과학과 팀장 (통합과학, 화학)", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "건국대학교 화학과", "knowsAbout": "과학, 화학" } },
          { "@type": "ListItem", "position": 21, "item": { "@type": "Person", "name": "김규리", "jobTitle": "옥정캠퍼스 과학 전임 강사 (통합과학, 생물, 물리)", "worksFor": { "@type": "EducationalOrganization", "name": "미래인재학원" }, "alumniOf": "성신여자대학교", "knowsAbout": "과학, 생물, 물리" } }
        ]
      };
      const script = document.createElement('script');
      script.id = 'schema-teachers';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(teacherSchemaData);
      document.head.appendChild(script);
    }

    return () => {
      const schemaEl = document.getElementById('schema-teachers');
      if (schemaEl) schemaEl.remove();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = departments.map(dept => ({
        name: dept.name,
        el: document.getElementById(`dept-${dept.name}`)
      }));
      const offset = 180;
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = sections[i].el;
        if (el && el.getBoundingClientRect().top <= offset) {
          setActiveTab(sections[i].name);
          return;
        }
      }
      setActiveTab('');
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToDept = (name: string) => {
    const el = document.getElementById(`dept-${name}`);
    if (el) {
      const offset = 140;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const getTeacherImage = (id: number, name: string) => {
    // 특정 ID에 대한 이미지 매핑
    const imageMap: Record<number, string> = {
      1: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8074ae6fc1575fe5347c9c5ed932ab74.png',
      2: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/95d2555a6acb90c5ae68d7a33eb26649.png',
      3: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5ee17a1e57c8a97c0baf51278716bd.png',
      6: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/9c5d3e3c095cfbe04233e34718c0b6af.png',
      4: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/3f6bb55f17c81488498b6ad213f017ec.png',
      5: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/926a5eb0d6b64320fdc9b0a0fd78e885.png',
      7: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d80606481a08d4f171d1f863c253e822.png',
      9: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/afcc3ca935f8184af89bb6b6ee2a87a2.png',
      8: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/3cae2e6506e7e8ece10d6f56a066f69d.png',
      10: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/5bb077b5e389919f0265282fbb51f7f8.png',
      11: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/cac3aedb695ffe3da5db427fd304da0d.png',
      12: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/8eba555c1658fcb734fd74f649ba05b9.png',
      13: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/7a779d0893bd7dcf31d6a7846b047692.png',
      14: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/5dc772f8953652d8503e67aa753f4819.png',
      15: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/02f88e4a1fd4257f1a6fce6a1a1f0810.png',
      16: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/2237483f5e3e4de0fa64377b02261fd1.png',
      17: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/00907245bd23f2e07b91a3d800992242.png',
      18: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/614cb379f3aa71f5ebcf29330c5438cb.png',
      19: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/e07bea73578d3402e3f33b5ce6d29d92.png',
      20: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/6f7e5c208140b07f81c6487697222e0e.png',
      21: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/affecb58eaf309058b20228dc4536fb4.png',
    };

    if (imageMap[id]) {
      return imageMap[id];
    }
    
    const isFemale = ['고민정', '이미현', '황지현', '정재은', '박지은', '남보람', '김아현', '김지원', '민세인', '임소희', '김규리', '최정윤'].includes(name);
    const gender = isFemale ? 'female' : 'male';
    const ages = ['30s', '40s', 'early 30s', 'late 30s'];
    const age = ages[id % ages.length];
    
    if (isFemale) {
      return `https://public.readdy.ai/ai/img_res/79bf730cb3fd3e4eee98a9d4c38b5a16.jpg$%7Bage%7D%20wearing%20elegant%20black%20professional%20attire%20warm%20smile%20clean%20white%20studio%20background%20portrait%20style%20professional%20headshot%20high%20quality%20photo&width=300&height=400&seq=teacher-dept-${id}&orientation=portrait`;
    }
    return `https://readdy.ai/api/search-image?query=Professional%20Korean%20male%20teacher%20in%20his%20$%7Bage%7D%20wearing%20formal%20black%20suit%20confident%20smile%20clean%20white%20studio%20background%20portrait%20style%20professional%20headshot%20high%20quality%20photo&width=300&height=400&seq=teacher-dept-${id}&orientation=portrait`;
  };

  const deptColors: Record<string, string> = {
    '수학과': 'from-rose-500 to-red-600',
    '영어과': 'from-emerald-500 to-teal-600',
    '국어과': 'from-amber-500 to-orange-600',
    '과학과': 'from-sky-500 to-cyan-600',
  };

  const deptActiveColors: Record<string, string> = {
    '수학과': 'bg-rose-500 text-white shadow-lg shadow-rose-500/30',
    '영어과': 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/30',
    '국어과': 'bg-amber-500 text-white shadow-lg shadow-amber-500/30',
    '과학과': 'bg-sky-500 text-white shadow-lg shadow-sky-500/30',
  };

  const deptInactiveColors: Record<string, string> = {
    '수학과': 'bg-rose-50 text-rose-600 hover:bg-rose-100 border border-rose-200',
    '영어과': 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100 border border-emerald-200',
    '국어과': 'bg-amber-50 text-amber-600 hover:bg-amber-100 border border-amber-200',
    '과학과': 'bg-sky-50 text-sky-600 hover:bg-sky-100 border border-sky-200',
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentPage="teachers" />
      
      {/* Hero Section */}
      <section className="pt-20 relative min-h-[350px] flex items-center bg-black">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center w-full">
          <span className="inline-block px-4 py-2 bg-amber-500/20 border border-amber-500/30 rounded-full mb-6">
            <span className="text-amber-400 text-sm font-medium">Our Teachers</span>
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            미래인재학원 <span className="text-amber-400">강사진</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            <span className="hidden sm:inline">항상 학생을 먼저 생각하는 강사가 되도록 노력하겠습니다</span>
            <span className="sm:hidden">
              항상 학생을 먼저 생각하는 강사가 되도록<br />
              노력하겠습니다
            </span>
          </p>
        </div>
      </section>

      {/* Department Tab Navigation */}
      <div className="sticky top-[64px] z-30 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-2 sm:px-4">
          <div className="flex items-center justify-center gap-1.5 sm:gap-3 py-5">
            {departments.map((dept) => (
              <button
                key={dept.name}
                onClick={() => scrollToDept(dept.name)}
                className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeTab === dept.name
                    ? deptActiveColors[dept.name]
                    : deptInactiveColors[dept.name]
                }`}
              >
                <i className={`${dept.icon} text-base hidden sm:inline-block`}></i>
                {dept.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Teachers by Department */}
      {departments.map((dept, deptIndex) => (
        <section id={`dept-${dept.name}`} key={dept.name} className={`py-16 px-4 ${deptIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
          <div className="max-w-7xl mx-auto">
            {/* Department Header */}
            <div className="flex items-center gap-4 mb-10">
              <div className={`w-14 h-14 bg-gradient-to-br ${dept.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                <i className={`${dept.icon} text-2xl text-white`}></i>
              </div>
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900">{dept.name}</h3>
              </div>
            </div>

            {/* Teachers Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {dept.teachers.map((teacher) => (
                <div key={teacher.id} className="bg-white group">
                  {/* 사진 영역 */}
                  <div 
                    className="relative overflow-hidden bg-gray-100 mb-4 rounded-lg"
                  >
                    <div className="aspect-[3/4] w-full">
                      <img 
                        src={getTeacherImage(teacher.id, teacher.name)}
                        alt={teacher.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                  
                  {/* 이름 */}
                  <div className={`border-l-4 pl-4 mb-3`} style={{ borderColor: deptIndex === 0 ? '#f43f5e' : deptIndex === 1 ? '#10b981' : deptIndex === 2 ? '#f59e0b' : '#0ea5e9' }}>
                    <h4 className="text-xl font-bold text-gray-900">{teacher.name}</h4>
                  </div>

                  {/* 이력 */}
                  <ul className="space-y-1 pl-4">
                    {teacher.careers.map((career, idx) => (
                      career ? (
                        <li key={idx} className="text-xs sm:text-sm text-gray-600 flex items-start gap-2 min-h-[20px]">
                          <span className="text-amber-500 mt-1">•</span>
                          <span>{career}</span>
                        </li>
                      ) : null
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            최고의 강사진과 함께하세요
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed">
            <span className="md:hidden">체계적인 커리큘럼과 전문 강사진이<br />함께합니다</span>
            <span className="hidden md:inline">체계적인 커리큘럼과 전문 강사진이 함께합니다</span>
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-10 py-4 bg-amber-400 text-black text-lg font-bold rounded-full hover:bg-amber-300 transition-all shadow-xl shadow-amber-400/20 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            입학상담
          </Link>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
